module.exports = __webpack_public_path__ + "img/hr-filter-inserter-hand-base.db5eef2e.png";